import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Skill } from '@shared';

@Component({
  selector: 'mojo-candidate-resume-skills',
  templateUrl: './candidate-resume-skills.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateResumeSkillsComponent {
  @Input() softSkills: Array<Skill>;

  @Input() hardSkills: Array<Skill>;

  @Input()
  keywords: string[];
}
